<template>
  <div :class="['repeatableButtons', {'w3-dropdown-content': !repeatableGroupOpen}, {'w3-animate-opacity': !repeatableGroupOpen}]">
    <button v-on:click="callAdd($event)" class="w3-btn w3-round-large add" :disabled="(validateAddForm && validateAddForm.validatingAdd) || (validateForm && validateForm.validating)">
      <transition-group name="fade" mode="out-in">
        <spinner-loading v-show="(validateAddForm && validateAddForm.validatingAdd) || (validateForm && validateForm.validating)" :line-size='2' line-fg-color='#5dbecd' key="loadingAddButton" />
        <span v-show="(!validateAddForm || !validateAddForm.validatingAdd) && (!validateForm || !validateForm.validating)" key="textAddButton" ><i class="sherpa-icon icon-anadir-generico"></i> <span class="add">{{ getLang('add') }}</span> {{label}}</span>
      </transition-group>
    </button>

    <!-- Form messages -->
    <!--
    <action-message
      :language="language"
      :formErrors="formErrors"
      :formAddErrors="formAddErrors"
      :formModifyErrors="formModifyErrors"
      :formSaved="formSaved"
      :formAddSaved="formAddSaved"
      :formSavedError="formSavedError"
      :formSavedErrorMsg="formSavedErrorMsg"
      :formDeleted="formDeleted"
      :resultSuccessMsg="resultSuccessMsg"
      :authorization="authorization"
      :visuals="visuals"
      :apiparams="apiparams"
      @popupClose="popupClose"
    />
    -->
  </div>
</template>

<script>
import language from '../language'
import ActionMessage from './message'
import SpinnerLoading from 'vue-simple-spinner'

export default {
  name: 'definition-repeatable-group-add-button',
  props: [
    'repeatableGroupOpen',
    'validateAddForm',
    'validateForm',
    'language',
    'formErrors',
    'formAddErrors',
    'formModifyErrors',
    'formSaved',
    'formAddSaved',
    'formSavedError',
    'formSavedErrorMsg',
    'formDeleted',
    'resultSuccessMsg',
    'authorization',
    'visuals',
    'apiparams',
    'label'
  ],
  components: {
    ActionMessage,
    SpinnerLoading
  },
  methods: {
    callAdd (event) {
      if (event.layerY >= 0) {
        this.$emit('callAdd')
      }
    },
    getLang (key, params, values) {
      return language(this.language, key, params, values)
    },
    popupClose () {
      this.$emit('popupClose')
    }
  }
}
</script>

<style lang="scss">
.repeatableButtons {
  z-index: 10000;
  border: 0;
  border-radius: 0;
  float: left;
  width: 100%;
  padding: 0 4px 12px;
  border-bottom: 2px solid #dadada;
  margin-bottom: 10px;

  button {
    margin: 10px auto;
    display: block;
    width: 100%;
    border-radius: 3px;
    transition: all 0.2s ease-in;
    background-color: #fff;
    border: 1px dotted #5dbecb;

    &:hover {
      box-shadow: 0 2px 4px 0 rgba(200,200,200,0.2), 0 1px 5px 0 rgba(200,200,200,0.19);
    }

    &:focus {
      outline: 0;
    }

    span {
      font-family: Capriola;
      font-size: 20px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: center;
      color: #5dbecb;
      letter-spacing: 1px;
      text-transform: uppercase;

      &.add {
        text-transform: uppercase;
      }

      i {
        text-transform: none;
        font-size: 14px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// node_modules/vue-definition/src/components/action/addButton.vue